"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Capitalization = void 0;
/**
 * The enum used for controlling the capitalization of text.
 * Used by changeCapitalization API
 */
var Capitalization;
(function (Capitalization) {
    /**
     * Transforms the first character after punctuation mark followed by space
     * to uppercase and the rest of characters to lowercase.
     */
    Capitalization["Sentence"] = "sentence";
    /**
     * Transforms all characters to lowercase
     */
    Capitalization["Lowercase"] = "lowercase";
    /**
     * Transforms all characters to uppercase
     */
    Capitalization["Uppercase"] = "uppercase";
    /**
     * Transforms the first character of each word to uppercase
     */
    Capitalization["CapitalizeEachWord"] = "capitalize";
})(Capitalization = exports.Capitalization || (exports.Capitalization = {}));
//# sourceMappingURL=Capitalization.js.map